/* eslint-disable react/prop-types */

import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { Badge } from '../../Global/Icons';
import ImageWithLoader from './ImageWithLoader';
import getRoundedPrice from '../../../utils/getRoundedPrice';

class Product extends React.Component {
	constructor() {
		super();

		this.state = {
			currentImage: 1,
			error: false,
		};

		this.addToCart = this.addToCart.bind(this);
		this.nextImage = this.nextImage.bind(this);
		this.prevImage = this.prevImage.bind(this);
		this.shouldShowError = this.shouldShowError.bind(this);
		this.getTags = this.getTags.bind(this);
		this.getBadges = this.getBadges.bind(this);
	}

	getTags() {
		return _.filter(_.split(this.props.item.attrs.tags, ', '), tag => !!tag);
	}

	getBadges() {
		const badgesMap = {
			'limited edition': <span key="limited" className="details__badge details__badge--limited">LIMITED EDITION</span>,
			'almost gone': <span key="almost-gone" className="details__badge details__badge--almost-gone">ALMOST GONE</span>,
			'back in stock': <span key="back-in-stock" className="details__badge details__badge--back-in-stock">BACK IN STOCK</span>,
		};
		const badges = _.map(this.getTags(), tag => badgesMap[tag]);

		return !_.isEmpty(badges) ? <div className="details__badges">{badges}</div> : null;
	}

	getCurrentImage() {
		if (this.props.item.images[this.state.currentImage - 1]) {
			return this.props.item.images[this.state.currentImage - 1].src;
		}
		return null;
	}

	shouldShowError() {
		if (this.state.error) {
			return (
				<div className="details__error-message">
					Sorry, there was a problem adding this to your cart. Try again?
				</div>
			);
		}
		return null;
	}

	nextImage() {
		if (this.state.currentImage === this.props.item.images.length) {
			this.setState({ currentImage: 1 });
		} else {
			this.setState({ currentImage: this.state.currentImage + 1 });
		}
	}

	prevImage() {
		if (this.state.currentImage === 1) {
			this.setState({ currentImage: this.props.item.images.length });
		} else {
			this.setState({ currentImage: this.state.currentImage - 1 });
		}
	}

	addToCart() {
		this.setState({ error: false });
		this.props.cart.createLineItemsFromVariants({ variant: this.props.item.selectedVariant, quantity: 1 })
			.then((newCart) => {
				this.props.updateCart(newCart);
			})
			.catch((err) => {
				this.setState({ error: true });
				console.error(`There was a problem updating the cart. ${err}`);
			});
	}

	buyButton() {
		if (this.props.shopClosedUntilDate) {
			return (
				<div className="unavailable-message">
					Available {this.props.shopClosedUntilDate}
				</div>
			);
		}

		return (
			<button className="button button--add-to-cart" onClick={this.addToCart}>Add to Cart</button>
		);
	}

	render() {
		const item = this.props.item;
		const badges = this.getBadges();
		const isSoldOut = !item.selectedVariant.available;
		const classes = classnames('product', item.attrs.handle);
		const description = {
			__html: item.description,
		};

		let price;

		if (item.selectedVariant.available) {
			price = getRoundedPrice(item.selectedVariant.price);
		} else {
			price = 'Sold out';
		}

		return (
			<div className={classes}>
				<div className="product__contents">
					<div className="product__image__container">
						<ImageWithLoader src={this.getCurrentImage()} alt={item.title} />
						{this.props.item.images.length > 1 && (
							<div className="product__image__navigation">
								<svg onClick={this.prevImage} viewBox="0 0 40 40" title="Previous">
									<polygon points="32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797
									3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 " />
								</svg>
								<svg onClick={this.nextImage} viewBox="0 0 40 40" title="Next">
									<polygon points="32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797
									3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 " />
								</svg>
							</div>
						)}

						{item.attrs.handle === 'mystery-kitty-sticker-packs' && (
							<div className="product__image__badge product__image__badge--mystery-kitties">
								<Badge />
								<div className="badge__text">3-Pack</div>
							</div>
						)}

						{_.includes(this.getTags(), 'new') && (
							<div className="product__image__badge">
								<Badge />
								<div className="badge__text">New</div>
							</div>
						)}
					</div>
					<div className="product__details">
						<div className="details__badges">{badges}</div>
						<h3 className="details__title">{item.title}</h3>
						<div className="details__price">{price}</div>
						<div className="details__description" dangerouslySetInnerHTML={description} />
						{!isSoldOut && this.buyButton()}
						{this.shouldShowError()}
						{isSoldOut && (
							<div className="unavailable-message"><p>Tell us if you want more!<br />Email <a className="site-link" href="mailto:meow@tabbycats.club">meow@tabbycats.club</a>.</p></div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/Product.js